<template>
  <el-dialog :visible="modalIA" @close="close">
      <p>{{ $t('socialPosts.create.modalAI.objectTitle') }}</p>

        <hr>
      <p v-html="$t('socialPosts.create.modalAI.objectSubtitle')">
      </p>
<!--      <el-input v-model="contextIA"></el-input>-->
    <div class="wait-captionIA" v-if="loadingStatusIAGeneration">
      <p>{{ $t('posts.IA.textSpinnerIA') }}</p>
      <div><Stretch /><br><br></div>
    </div>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'initial'"
                :value="editorialPost.initial.iaPrompt"
                @input="setInitialIaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'facebook'"
                :value="editorialPost.facebook.iaPrompt"
                @input="setFacebookIaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'google'"
                :value="editorialPost.google.iaPrompt"
                @input="setGoogleIaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'instagram'"
                :value="editorialPost.instagram.iaPrompt"
                @input="setInstagramIaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'linkedin'"
                :value="editorialPost.linkedin.iaPrompt"
                @input="setLinkedInIaPrompt"></el-input>
    <el-row>
      <el-col :lg="24">{{ generatedText }}</el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
              <el-button @click="close">{{ $t('socialPosts.create.modalAI.cancel') }}</el-button>
              <el-button type="primary" @click="generatePostIA()" :disabled="loadingStatusIAGeneration">{{ $t('socialPosts.create.modalAI.generatePost') }}</el-button>
            </span>
  </el-dialog>
</template>

<script>
import Stretch from '@/components/spinners/Stretch'

const NS = 'socialPostsCreationPostEditorial'

export default {
  name: 'PostEditoCreateModalIA',
  /** Conservée pour l’appelant (:post="post") ; les prompts IA viennent du store (aligné dispatchEditorialIaGeneration). */
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  components: {
    Stretch
  },
  data () {
    return {
      promptIA: '',
      generatedText: '',
      contextIA: ''
    }
  },
  computed: {
    /** Équivalent mapState — explicite pour l’IDE / ESLint. */
    modalIA () {
      return this.$store.state[NS].modalIA
    },
    networkClicked () {
      return this.$store.state[NS].networkClicked
    },
    loadingStatusIAGeneration () {
      return this.$store.state[NS].loadingStatusIAGeneration
    },
    editorialPost () {
      return this.$store.state[NS].post
    }
  },
  methods: {
    setInitialIaPrompt (value) {
      this.$store.commit(`${NS}/setInitialIAPrompt`, value)
    },
    setFacebookIaPrompt (value) {
      this.$store.commit(`${NS}/setFacebookIAPrompt`, value)
    },
    setGoogleIaPrompt (value) {
      this.$store.commit(`${NS}/setGoogleIAPrompt`, value)
    },
    setInstagramIaPrompt (value) {
      this.$store.commit(`${NS}/setInstagramIAPrompt`, value)
    },
    setLinkedInIaPrompt (value) {
      this.$store.commit(`${NS}/setLinkedInIAPrompt`, value)
    },
    generatePostIA () {
      this.$store.dispatch(`${NS}/dispatchEditorialIaGeneration`, {
        network: this.networkClicked
      })
      // Loading will be stopped by resetCaption.finally()
    },
    confirm () {
      this.$store.commit(`${NS}/setModalIA`, false)
    },
    close () {
      this.$store.commit(`${NS}/setModalIA`, false)
    }
  }
}
</script>

<style scoped>
.wait-captionIA {
  width: 100%;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wait-captionIA p {
  width: 350px;
  font-weight: 600;
  color: #0ab1bf;
}
</style>
